import { Component, Input, HostBinding, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { AppService } from '../../app.service';
import { LayoutService } from '../../layout/layout.service';
import { ApiService } from 'src/app/service/api.service';
import { Login } from 'src/app/model/login';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LiberacaoManualPopupComponent } from 'src/app/others-component/liberacaomanual-popup/liberacaomanual-popup.component';
import { NewPasswordPopupComponent } from 'src/app/others-component/new-password-popup/new-password-popup.component';
import { debounceTime, switchMap, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-layout-navbar',
  templateUrl: './layout-navbar.component.html',
  styles: [':host { display: block; }'],
  styleUrls: [
    '../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
    '../../../vendor/libs/ng-select/ng-select.scss'
  ]
})
export class LayoutNavbarComponent {
  isExpanded = false;
  isRTL: boolean;
  img: string = null;
  private delayRefresh; // Timer get dispositivos
  loading = [false];
  offline: boolean = true;
  searching = false;

  user: Login;

  @Input() sidenavToggle = true;

  state: any = {
    searchQuery: '',
    list: null,
    listFilterDevices: null,
    paging: null,
    usuarios: null,
    pagingUsuarios: null,
    is404: [false]
  }

  public form: FormGroup;
  public formDevice: FormGroup;


  get f() {
    return this.form.controls;
  }

  // https://stackblitz.com/run?file=src%2Fapp%2Ftypeahead-http.ts
  // https://ng-bootstrap.github.io/#/components/typeahead/examples
  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => this.getUsuariosPorSetorNomeEPerfil(term)),
      tap(() => this.searching = false)
    )

  @HostBinding('class.layout-navbar') hostClassMain = true;

  constructor(private appService: AppService, private layoutService: LayoutService, public apiService: ApiService,
    public translateService: TranslateService, private modalService: NgbModal,
    private cd: ChangeDetectorRef, private fb: FormBuilder, private router: Router) {
    this.isRTL = appService.isRTL;

    this.apiService.getUser().then((res: Login) => {
      this.user = res;

      if (this.user) {
        this.img = this.apiService.getUrlImage(this.user.conta.image, true);
      }

    });

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.form = this.fb.group({
      search_term: [null],
    });

    this.formDevice = this.fb.group({
      searchTerm: [null]
    })

    this.apiService.filteredDispositivosStatusObservable.subscribe(data => {

      if (!data)
        return

      this.state.paging = data.paging
      this.state.list = data.response

      if (!this.formDevice.value.searchTerm)
        this.filterDevices(null)

    });


  }

  filterDevices(searchText: string) {

    if (searchText && searchText.length > 0) {

      // Filtrando de acordo com a pesquisa
      this.state.listFilterDevices = this.state.list.filter(it => {
        return it.dis_descricao.toUpperCase().includes(searchText);
      })

    } else {
      this.state.listFilterDevices = this.state.list
    }

    this.offlineCheck();
  }


  ngOnDestroy() {
    clearTimeout(this.delayRefresh);
    this.delayRefresh = null;

  }

  currentBg() {
    return `bg-${this.appService.layoutNavbarBg}`;
  }

  toggleSidenav() {
    this.layoutService.toggleCollapsed();
  }

  logout() {

    this.apiService.logout(true);

  }

  //#region DISPOSITIVOS  

  offlineCheck() {
    if (this.state.list) {

      let temDispositivoOffline = false;
      for (let index = 0; index < this.state.list.length; index++) {
        const o = this.state.list[index];

        if (!o.dis_online) {
          temDispositivoOffline = true;
          break;
        }

      }

      this.offline = temDispositivoOffline;

    }
  }



  get getNomeUsuario() {
    let retorno = '';

    if (this.user) {
      retorno = this.apiService.getFirstWord(this.user.conta.con_usuario);
    }

    return retorno;
  }

  get getNomeCliente() {
    let retorno = '';

    if (this.user) {
      retorno = this.apiService.getFirstWord(this.user.conta.con_usuario);
    }

    return retorno;
  }


  //#endregion

  //#region POPUP_LIBERACAO_MANUAL
  async openLiberacaoManualPopup(o) {

    let options = { windowClass: 'modal-lg nested-modal' };

    let modal = this.modalService.open(LiberacaoManualPopupComponent, options);

    (<LiberacaoManualPopupComponent>modal.componentInstance).dispositivoView = o;

    modal.result.then((result) => {



    }, (reason) => {
      // modal foi cancelado/fechado
      console.log(`Dismissed ${reason}`);

    });

  }

  //#endregion



  //#region NEW_PASSWORD
  openNewPasswordPopup() {

    let options = { windowClass: 'modal-top modal-lg animate' };

    let modal = this.modalService.open(NewPasswordPopupComponent, options); // Render modal with modal component    

    setTimeout(() => {

      let parameters = {
        pk_idconta: this.user.idConta,
        con_senha: this.user.conta.con_senha
      };

      (<NewPasswordPopupComponent>modal.componentInstance).add(parameters);

    }, 200);

    modal.result.then((result) => {
      console.log(`Closed with: ${result}`);

      if (result) {
        // return a new password from popup
        this.user.conta.con_senha = result;


      }

    }, (reason) => {

    });

  }

  //#endregion

  //#region USUARIO
  async getUsuariosPorSetorNomeEPerfil(term: string = null, offset: number = 0) {

    try {

      this.state.is404[2] = false;
      this.loading[2] = true;

      if (!term || term.length <= 2)
        return;

      let params = {
        searchQuery: term,
        empresa: 0,
        setor: 0,
        offset,
        idperfisdeacesso: null, // perfil: Morador e Funcionario, este ultimo depende de configuracao
        status: 'A',
        rowLimit: 5
      }

      let data = await this.apiService.getUsuariosPorSetorNomeEPerfil(params);

      this.state.pagingUsuarios = data.paging;

      this.loading[2] = false;

      if (offset == 0) {
        this.state.usuarios = data.response;
      } else {
        // Add more row in list
        this.state.usuarios = this.state.usuarios.concat(data.response);
      }

    } catch (error) {

      this.state.usuarios = null;

      this.loading[2] = false;

      if (error && error.status != 401 && error.status != 404) {
        this.apiService.errorMessageShow(error);
      }

      // Nenhum registro foi cadastrado
      this.state.is404[2] = error.status == 404;

    }

    return this.state.usuarios;

  }

  formatter = (x: { usu_nome: string }) => x.usu_nome;

  selectedItem(item) {

    let obj = item.item;
    // redirecionando de acordo com o perfil da pessoa selecionada
    // redirect to view 
    // https://www.digitalocean.com/community/tutorials/angular-query-parameters

    this.router.navigate(['/people/person', obj.pk_idusuario, 'edit'], { queryParams: { refresh: new Date().getTime(), perfil: obj.fk_idperfisdeacesso } });


  }

  clear() {
    this.form.patchValue({
      search_term: null
    })
  }

  openAccount() {

    // redirect person to new id
    this.router.navigate(['/people/user', this.user.idConta, 'edit']);

  }

  //#endregion



}
